import { Check, WarningOutlined, WatchLater } from '@mui/icons-material';
import { ReactElement } from 'react';

import { VendorActivationStatus } from 'entities/Vendors';

export interface StatusConfig {
    icon: ReactElement;
    labelKey: string;
    labelDefault: string;
    backgroundColor: string;
    color: string;
    tooltipBodyKey: string;
    tooltipBodyDefault: string;
}

export const STATUS_CONFIG: Record<
    Exclude<VendorActivationStatus, VendorActivationStatus.INITIAL>,
    StatusConfig
> = {
    [VendorActivationStatus.VERIFYING]: {
        icon: (
            <WatchLater
                sx={{
                    fontSize: '14px !important',
                    color: '#E68A00 !important',
                }}
            />
        ),
        labelKey: 'supplierStatus.pending.label',
        labelDefault: 'Pending',
        backgroundColor: 'rgba(230, 138, 0, 0.15)',
        color: '#E68A00',
        tooltipBodyKey: 'supplierStatus.pending.tooltipBody',
        tooltipBodyDefault:
            'Supplier is in the process of enabling your account.\nYour account must be enabled to submit orders.',
    },
    [VendorActivationStatus.INVALID]: {
        icon: (
            <WarningOutlined
                sx={{
                    fontSize: '14px !important',
                    color: '#FF0000 !important',
                }}
            />
        ),
        labelKey: 'supplierStatus.actionRequired.label',
        labelDefault: 'Action required',
        backgroundColor: 'rgba(255, 0, 0, 0.1)',
        color: '#FF0000',
        tooltipBodyKey: 'supplierStatus.actionRequired.tooltipBody',
        tooltipBodyDefault:
            'Supplier is experiencing an issue enabling your account.\n' +
            'Please contact them to resolve the issue.\n' +
            'Your account must be enabled to submit orders.',
    },
    [VendorActivationStatus.VERIFIED]: {
        icon: (
            <Check
                sx={{
                    fontSize: '14px !important',
                    color: '#009F3A !important',
                }}
            />
        ),
        labelKey: 'supplierStatus.enabled.label',
        labelDefault: 'Enabled',
        backgroundColor: '#DBEFE1',
        color: '#009F3A',
        tooltipBodyKey: 'supplierStatus.enabled.tooltipBody',
        tooltipBodyDefault: 'Product ordering enabled',
    },
};
